<script lang="ts">
  import { errorsIf, formField } from "../";
  import { onMount } from "svelte";
  import FieldLable from "./FieldLabel.svelte";

  export let name: string | undefined = undefined;
  export let key: string;
  export let hideBorder = false;
  export let maxHeight = "200px";
  export let selectionColor: string | undefined = undefined;
  export let id: string | undefined = Math.random().toString(36).substr(2, 9);

  // Validation
  export let limit: number = 0;
  export let rows: number = 2;
  export let required = false;
  export let placeholder = "";
  export let autofocus = false;
  export let inputEl: HTMLTextAreaElement | undefined = undefined;
  export let disableErrors = false;

  const field = formField<string>(key, name);
  // Reactive validations
  $: $field.errors = errorsIf(
    required && (!$field.value || $field.value.trim().length === 0) && "is required",
    !!limit && !!$field.value && $field.value!.length > limit && "Too long"
  );
  $: numOfCharsLeft = limit - ($field.value || "").length;
  onMount(() => {
    if (autofocus) {
      setTimeout(() => {
        if (inputEl) {
          inputEl.select();
        }
      }, 100);
    }
  });
</script>

<FieldLable
  {name}
  {required}
  {id}
  errorMessage={$field.errors.length && $field.isDirty && !disableErrors ? $field.errors[0]?.message : undefined}>
  <div class="relative">
    <textarea
      {rows}
      name={id}
      on:keydown
      bind:value={$field.value}
      disabled={$field.isDisabled}
      style={(hideBorder ? "--border-focus: none;" : "") +
        "--max-height:" +
        maxHeight +
        ";--selection-color:" +
        (selectionColor || "#dcf4f1")}
      class="form-textarea rounded mt-1 block p-3 w-full {hideBorder
        ? 'border-none'
        : 'border-gray-300 focus:border-teal-400'} transition-all text-13"
      class:pr-9={limit > 0}
      {placeholder}
      bind:this={inputEl} />
    {#if limit > 0}
      <span
        class="absolute top-0 right-0 pt-1.5 pr-2 mt-px text-sm char-counter"
        class:text-gray-500={numOfCharsLeft > 9}
        class:text-orange-600={numOfCharsLeft <= 9 && numOfCharsLeft >= 0}
        class:text-red-600={numOfCharsLeft < 0}
        class:font-medium={numOfCharsLeft <= 9}>
        {numOfCharsLeft}
      </span>
    {/if}
  </div>
</FieldLable>

<style>
  .form-textarea {
    --border-focus: 0 0 0 4px #dcf4f1;

    resize: none;
    min-height: 40px;
    max-height: var(--max-height);
    padding: 0.25em 0.6rem;
  }
  .form-textarea:focus {
    outline: none;
    box-shadow: var(--border-focus);
  }

  .form-textarea::selection {
    background-color: var(--selection-color);
  }

  .form-textarea::-moz-selection {
    background-color: var(--selection-color);
  }
</style>
